import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router
} from "@angular/router";
import { Observable } from "rxjs";
import { AuthenticationService } from "../services/authentication.service";
import { jwtDecode } from 'jwt-decode';
import { Location } from '@angular/common';
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root"
})
export class LogeGuard implements CanActivate {
  constructor(
    private authService: AuthenticationService,
    private location: Location,
    private router: Router
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    let token: any = this.authService.getToken();
    let decodedToken: any;
    try {
      decodedToken = jwtDecode(token);
    } catch (e) {
      this.router.navigateByUrl('login');
      return false;
    }

    if (!token || this.authService.isTokenExpired(token)) {
      this.router.navigateByUrl('login');
      return false;
    }
    else if (token && !this.authService.isTokenExpired(token) &&
      (
        decodedToken['Role'] == "LOGE_" + environment.establishment
        || "CPE_" + environment.establishment
        || "DIRECTEUR_" + environment.establishment
      )
    ) {
      return true;
    } else {
      this.authService.clearToken();
      this.router.navigateByUrl('login');
      return false;
    }
  }
}
